import React from 'react';

import ContentBlock from '../components/editor/content';
import CreateARBlock from '../components/editor/create-block';
import TitleBlock from '../components/editor/title-block';
import SEO from '../components/seo';
import Spacer from '../components/spacer';

const Editor = () => (
  <>
    <SEO title="Create Ow Augmented Reality" />
    <Spacer />
    <TitleBlock />
    <ContentBlock />
    <CreateARBlock />
  </>
);

export default Editor;
